import React, { useEffect } from 'react';
import { HorizontalNoteContainer } from '../../model/containers';
import { TrackColor } from '../../render/trackColor';
import _ from 'lodash';
import { drawPianoRollCollapsed } from '../../render/canvasRenderer';
import { useZoomFactor } from '../../stores/ZoomStore';
import { ScrollController } from '../../utils/ScrollController';
import { useWorkspaceUIState } from '../../stores/WorkspaceStore';


export function PianoRollCollapsed({
    hnc,
    noteColor = TrackColor.DEFAULT_COLOR,
    scrollController,
    getCanvasWidth
}: {
    hnc: HorizontalNoteContainer,
    noteColor?: TrackColor.Color,
    scrollController?: ScrollController,
    getCanvasWidth: () => number,
}) {

    const zoomFactor = useZoomFactor();
    const canvasRef = React.useRef<HTMLCanvasElement>(null);
    const [offset, setOffset] = React.useState(0);
    const workspaceUiState = useWorkspaceUIState();

    const canvasWidth = 0 | getCanvasWidth();

    const canvasHeight = 60; // Fixed height for the collapsed view
    const grid = hnc.getGrid(true);

    useEffect(() => {
        if (!scrollController) return;
        const listenerId = scrollController.listen(setOffset);
        return () => {
            scrollController?.drop(listenerId);
        }
    }, []);

    useEffect(() => {
        if (!canvasRef.current) return;
        const canvas = canvasRef.current;

        drawPianoRollCollapsed(canvas, workspaceUiState.newNoteDuration, grid, noteColor, canvasWidth, canvasHeight, zoomFactor, hnc.getPPQ(), offset);

    }, [hnc, workspaceUiState.newNoteDuration, zoomFactor, offset]);

    return (<canvas
        ref={canvasRef}
        width={canvasWidth * 2}
        height={canvasHeight * 2}
        style={{
            position: 'absolute',
            left: `calc(var(--piano-roll-header-width) + ${offset}px)`,
            height: `${canvasHeight}px`,
            width: `${canvasWidth}px`,

        }} />);
}